module.exports = __webpack_public_path__ + "img/8.7a20bd9c.jpg";